import { colorsPalettes } from "@similarweb/styles";

import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { AdNetworkSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import TruncatedTextWithTooltip from "app/pages/sales-intelligence/pages/company-analysis/components/shared/TruncatedTextWithTooltip/TruncatedTextWithTooltip";
import type { SignalsDescription } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalsDescription";
import type SignalAdNetwork from "app/pages/sales-intelligence/sub-modules/signals/models/ad-network/SignalAdNetwork";

type AdNetworkSignalEventInfoProps = {
    signal: AdNetworkSignalEventDto;
    companyName: string;
    signalsDescription: Readonly<SignalsDescription> | null;
};

const AdNetworkSignalEventInfoBox = ({ signal, companyName, signalsDescription }: AdNetworkSignalEventInfoProps) => {
    if (!signalsDescription) {
        return null;
    }

    const { adNetworks } = signalsDescription;
    const { adNetworkIds } = signal;

    if (adNetworkIds.length === 1) {
        return null;
    }

    const adNetworksNames = adNetworkIds
        .map((adNetworkId: number) => adNetworks.find((network: SignalAdNetwork) => network.id === adNetworkId)?.name)
        .filter((adNetworkName) => !!adNetworkName) as string[];

    const text = `${signalEventsService.getAdNetworkSignalEventActionText(signal, companyName)} ${adNetworksNames.join(", ")}`;

    return (
        <TruncatedTextWithTooltip
            height={32}
            text={text}
            textStyles={{
                fontVariant: "input2",
                color: colorsPalettes.carbon[300],
            }}
        />
    );
};

export default AdNetworkSignalEventInfoBox;
